<template>
  <div id="profile-canvas" class="offcanvas-background">
    <div
      class="offcanvas offcanvas-right"
      v-click-outside="close">
      <!--begin::Header-->
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
        <div class="d-flex align-items-center">
          <span class="font-weight-light" style="font-size: 2.5rem">
              {{$t('profile.title')}}
          </span>
        </div>
        <a class="btn btn-xs btn-icon btn-hover-primary ml-auto"
           @click="close">
          <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                      width="20" height="20"/>
        </a>
      </div>
      <!--end::Header-->
      <!--begin::Content-->
      <div class="offcanvas-content px-4 px-md-7 pb-8">
        <div class="profile-info">
          <div class="row">
            <div class="user-info__image rounded-circle position-relative mr-4 mb-5 col-4">
              <img
                v-if="currentUser.avatarURL"
                class="cover-fit border-pad w-160px h-160px"
                :src="userAvatar"
                alt="">
              <div v-else class="avatar-placeholder big">
                {{currentUser.initials}}
              </div>
            </div>
            <div class="profile-info__line mb-2 col-6 align-center  display-flex align-self-center">
              <span class="font-weight-bold">{{currentUser.firstName}}</span>
              <span class="font-weight-bold"> {{currentUser.lastName}}</span>
              <div class="profile-info__line mb-4">
                <span class="font-weight-lighter ">{{currentUser.login}}</span>
              </div>
              <div class="language-switcher mb-4">
                <LanguageSwitcher
                  @language-changed="changeLanguage"
                />
              </div>
            </div>
          </div>
          <!-- Language Switcher -->

          <div v-if="showOrg && portal !== 'teams'">
            <router-link v-if="organizations.length > 1" :to="{name: 'Organizations'}"
                         class="btn btn-outline-primary btn-sm px-8 text-uppercase mb-2">
              {{$t('profile.change.instance')}}
            </router-link>
          </div>
          <button v-if="organization.organizationRole > 0"
                  class="btn btn-outline-primary btn-sm px-8 text-uppercase mb-2"
                  @click="openInstance(organization.id)">
            {{$t('app.show.vts.perform')}}
          </button>

          <button v-if="portal !== 'teams'"
                  class="btn btn-outline-primary btn-sm px-8 text-uppercase"
                  @click.stop="showPasswordForm">
            {{$t('profile.change.password')}}
          </button>
        </div>
        <div class="logout mt-10" v-if="portal !== 'teams'">
          <button class="btn btn-primary btn-sm px-8 text-uppercase" @click="logout">
            {{$t('profile.disconnect')}}
          </button>
        </div>
      </div>
      <!--end::Content-->
      <PasswordCanvas :class="{'offcanvas-on': showPassword}" @close="closePasswordForm"/>
    </div>
  </div>
</template>

<script>
import { LOGOUT, UPDATE_LOCALE } from '@/store/actions.type';
import PasswordCanvas from '@/components/canvas/PasswordCanvas.vue';
import { mapGetters } from 'vuex';
import { PERFORM_URL } from '@/common/config';
import LanguageSwitcher from '../ui/LanguageSwitcher.vue';

export default {
  name: 'ProfileCanvas',
  components: {
    PasswordCanvas,
    LanguageSwitcher,
  },
  computed: {
    ...mapGetters(['currentUser', 'userAvatar', 'organizations', 'organization', 'portal']),
  },
  data() {
    return {
      showPassword: false,
      langs: [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' },
      ],
    };
  },
  methods: {
    close() {
      if (document.getElementById('profile-canvas').classList.contains('offcanvas-on')) {
        this.$emit('close', { src: 'profile-canvas' });
      }
    },
    logout() {
      this.$store.dispatch(LOGOUT);
    },
    showPasswordForm() {
      this.showPassword = true;
    },
    closePasswordForm() {
      this.showPassword = false;
    },
    openInstance(orgId) {
      window.open(`${PERFORM_URL}/swaporganization?goto=${orgId}`);
    },
    changeLanguage(newLocale) {
      this.$store.dispatch(UPDATE_LOCALE, { locale: newLocale })
        .then(() => {
          this.$i18n.locale = newLocale;
          this.$Progress.finish();
        })
        .catch((error) => {
          console.error('Failed to update language:', error);
          this.$Progress.finish();
        });
      this.$i18n.locale = newLocale;
    },
  },
  props: {
    showOrg: {
      default: true,
      type: Boolean,
    },
  },
};
</script>
